"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Hyperlink = ({
  prefix,
  children,
  text,
  url,
  subtle,
  disabled,
  button,
  colour,
  className,
  onClick,
  newWindow,
  ariaControls,
  ...otherProps
}) => {
  function preventClick(e) {
    e.preventDefault();
  }

  const cssStyles = (0, _classnames.default)(className, `${prefix}link`, colour && `${prefix}link--${colour}`, subtle && `${prefix}link--subtle`, disabled && `${prefix}link--disabled`);
  return _react.default.createElement("a", _extends({
    target: newWindow ? '_blank' : null
  }, otherProps, {
    href: url,
    className: cssStyles,
    role: button ? 'button' : null,
    "aria-disabled": button && disabled ? `${disabled}` : null,
    "aria-controls": ariaControls ? ariaControls : null,
    onClick: button && disabled ? preventClick : onClick
  }), text && text.length > 0 ? text : '', text && children ? ' ' : null, children);
};

Hyperlink.defaultProps = {
  className: '',
  disabled: false,
  url: '#',
  button: false,
  newWindow: false,
  prefix: ''
};
var _default = Hyperlink;
exports.default = _default;